html:has(.dialog[open]) {
  overflow: hidden;
}

html {
  scrollbar-gutter: stable;
}

.dialog {
  max-width: 100vw;
  max-height: 100vh;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 10vh 0 0;
  border: none;
  background: transparent;
  align-items: flex-start;
  justify-content: center;

  &[open] {
    display: flex;
  }

  &::backdrop {
    background: rgba(0, 0, 0, 0.4);
  }
}

.panel {
  width: min(36rem, 90vw);
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  background: var(--color-background);
  border: 1px solid var(--color-gray-dim);
  border-radius: 0.75rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.input {
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1.125rem;
  border: none;
  background: transparent;
  color: var(--color-foreground);
  outline: none;

  &::placeholder {
    color: var(--color-gray);
  }
}

// Announces the result count to screen readers, which otherwise get no signal
// that anything happened when the list below the field changes.
.status {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip-path: inset(50%);
}

.results {
  border-top: 1px solid var(--color-gray-dim);
  overflow-y: auto;
  padding: 0.5rem 0;
}

.result {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  padding: 0.5rem 1.25rem;
  text-decoration: none;
  color: var(--color-foreground);
  cursor: pointer;

  &.active {
    background: var(--color-blue-alt-dim);
    color: var(--color-white);
  }
}

.displayText {
  font-size: 0.875rem;
  color: var(--color-foreground);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.highlight {
  background: none;
  color: var(--color-blue);
  font-weight: 600;
}

.breadcrumbs {
  font-size: 0.75rem;
  color: var(--color-blue-alt);
}

.empty {
  border-top: 1px solid var(--color-gray-dim);
  padding: 2rem 1.25rem;
  text-align: center;
  color: var(--color-gray);
}
